<template>
  <div class="pre_wrapper">
    <div class="head"></div>
    <div class="content">
      <div v-if="prew_type == 'mp4' || prew_content.type == 'Mp4'">
        <!-- <video >
                    <source :src="prew_content.url.indexOf('https://')>-1?prew_content.url:g_url+prew_content.url" type="video/mp4">
                    </video> -->
        <iframe :src="prew_content.img_list" frameborder="0" style="width: 100%; height: 60vh"></iframe>
      </div>
      <div v-if="prew_type == 'mp3'&&from_name==!'videotapeCompetition'">
        <!-- <audio style="width:200px;height:200px" controls=true  type="audio/mp3"  src='../../assets/images/1.mp3'></audio> -->

        <audio style="width: 80%; margin: 10% auto" controls="true" type="audio/mp3" :src="prew_content.url.indexOf('https://') > -1
            ? prew_content.url
            : g_url + prew_content.url
          "></audio>
      </div>
      <div v-if="prew_type == 'mp3'&&from_name=='videotapeCompetition'">
        <!-- <audio style="width:200px;height:200px" controls=true  type="audio/mp3"  src='../../assets/images/1.mp3'></audio> -->

        <audio style="width: 80%; margin: 10% auto" controls="true" type="audio/mp3" :src="prew_content.url.indexOf('https://') > -1
            ? prew_content.url
            : sessionStorage.server_url + prew_content.url
          "></audio>
      </div>
      <div v-if="prew_type == 'img'&&from_name!='videotapeCompetition'" style="overflow: auto">
        <img :src="prew_content.url.indexOf('https://') > -1
            ? prew_content.url
            : g_url + prew_content.url
          " alt="" style="max-height: 60vh" />
      </div>
      <div v-if="prew_type == 'img'&&from_name=='videotapeCompetition'" style="overflow: auto">
        <img :src="prew_content.url.indexOf('https://') > -1
            ? prew_content.url
            : sessionStorage.server_url + prew_content.url
          " alt="" style="max-height: 60vh" />
      </div>


      <div v-if="prew_type == 'teaching'">
        <div v-html="prew_content.content"></div>
      </div>
      <div v-if="prew_type == 'ppt'">
        <iframe v-if="prew_content.img_list" :src="prew_content.img_list" frameborder="0"
          style="width: 100%; height: 60vh"></iframe>
        <div v-if="!prew_content.img_list" style="text-align: center">
          {{ msg || '文件未转化完成！请稍后重试' }}
        </div>
      </div>
      <!-- <div v-if="prew_type=='ppt'&&!prew_content.img_list"> 
                   <div style="text-align:center">文件未转化完成！请稍后重试</div>
                </div> -->
      <div v-if="prew_type == 'pdf'">
        <iframe :src="prew_content.url.indexOf('https://') > -1
            ? prew_content.url
            : g_url + prew_content.url
          " frameborder="0" style="width: 100%; height: 60vh"></iframe>
      </div>
      <div v-if="prew_type == 'homework'">
        <div v-for="(item, index) in homework_list" :key="index">
          <h3>{{ item.name }}</h3>
          <div v-for="(item_t, index_t) in item.topicList" :key="index_t">
            <div v-html="index_t + 1 + '.' + item_t.content"></div>
            <div>
              答案：
              <div style="color: red" v-html="item_t.answer"></div>
            </div>
            <div>
              解析：
              <div v-html="item_t.analyzing"></div>
            </div>
            <hr />
          </div>
        </div>
      </div>
    </div>
    <div class="foot flex-center">
      <img @click="dowload" v-if="prew_type != 'teaching' && prew_type != 'homework'" title="下载" width="30px" height="30px"
        src="../../assets/images/下载.png" alt="">
    </div>
  </div>
</template>
<script>
var that;
import bus from "../../plugins/Bus";
export default {
  props: {
    prew_type: {
      type: String,
    },
    prew_content: {
      type: Object,
    },
    prew_cloud: String,
    from_name: String,
  },
  watch: {
    prew_content: function (val) {
      
      console.log(this.prew_cloud);
      //   console.log(val)
      // console.log(this.prew_content.homework_src_uuid)
      if (this.prew_type == "homework") {
        let formdata = new FormData();
        formdata.append(
          "uuid",
          this.prew_content.homework_uuid ||
          this.prew_content.uuid ||
          this.prew_content.homework_src_uuid
        );
        this.axios.post("/school/Homework/detail", formdata).then((res) => {
          this.homework_list = JSON.parse(res.data.data.data.content);
          // console.log(this.homework_list)
        });
      } else if (this.prew_type == "ppt") {
        let formdata = new FormData();
        formdata.append("url", this.prew_content.url);
        if (this.prew_cloud == "cloud") {
          formdata.append("from_cloud", 1);
        }
        this.axios
          .post("/school/upload/getResourceHtmlUrl", formdata)
          .then((res) => {
            this.prew_content.img_list = res.data.data.data.img_list;
            this.$forceUpdate();
            //    console.log( this.prew_content.img_list)
          });
      } else if (this.prew_type == "mp4" || this.prew_content.type == "Mp4") {
        if (
          this.prew_content.type == "mp4" ||
          this.prew_content.type == "MP4" ||
          this.prew_content.type == "Mp4"
        ) {
          if (this.prew_content.url.indexOf("http") > -1) {
            this.prew_content.img_list = this.prew_content.url;
            this.$forceUpdate();
          } else {
            this.prew_content.img_list = this.g_url + this.prew_content.url;
            this.$forceUpdate();
          }
          return;
        }
        let formdata = new FormData();
        formdata.append("url", this.prew_content.url);
        if (this.prew_cloud == "cloud") {
          formdata.append("from_cloud", 1);
        }
        this.axios
          .post("/school/upload/getResourceHtmlUrl", formdata)
          .then((res) => {
            //  console.log(res.data.code)

            this.prew_content.img_list = res.data.data.data.img_list;
            this.$forceUpdate();
            if (res.data.code == 0) {
              this.show_alert("error", res.data.msg);
            }
            //  console.log( this.prew_content.img_list)
          });
      }
    },
  },

  data() {
    return {
      g_url: "",
      homework_list: [],
      msg: "",
    };
  },
  computed: {},
  mounted() {
    this.g_url = JSON.parse(sessionStorage.userInfo).school.server_url;
    //   console.log(this.prew_content)
    if (this.prew_type == "homework") {
      let formdata = new FormData();

      formdata.append(
        "uuid",
        this.prew_content.homework_uuid ||
        this.prew_content.uuid ||
        this.prew_content.homework_src_uuid
      );
      let server_url = sessionStorage.server_url;
      let url =
        this.from_name == "videotapeCompetition"
          ? `${server_url}/school/Homework/detail`
          :( this.from_name == "research"?"/proxy2/cloud/upload/getResourceHtmlUrl":`${this.g_url}/school/Homework/detail`) ;
      
      this.axios.post(url, formdata).then((res) => {
        this.homework_list = JSON.parse(res.data.data.data.content);
      });
    
    } else if (this.prew_type == "ppt") {
      let formdata = new FormData();
      if (this.prew_cloud == "cloud") {
        formdata.append("from_cloud", 1);
      }
      formdata.append("url", this.prew_content.url);
      let server_url = sessionStorage.server_url;
      let url =
        this.from_name == "videotapeCompetition"
          ? `${server_url}/school/upload/getResourceHtmlUrl`
          :( this.from_name == "research"?"/proxy2/cloud/upload/getResourceHtmlUrl":`${this.g_url}/school/upload/getResourceHtmlUrl`) ;
      this.axios.post(url, formdata).then((res) => {
        this.msg = res.data.msg
        this.prew_content.img_list = res.data.data.data.img_list;
        this.$forceUpdate();
        //  console.log( this.prew_content.img_list)
      });
    } else if (this.prew_type == "mp4" || this.prew_content.type == "Mp4") {
      if (
        this.prew_content.type == "mp4" ||
        this.prew_content.type == "MP4" ||
        this.prew_content.type == "Mp4"
      ) {
        if (this.prew_content.url.indexOf("http") > -1) {
          this.prew_content.img_list = this.prew_content.url;
          this.$forceUpdate();
        } else {
          if (this.from_name == "videotapeCompetition") {
            let server_url = sessionStorage.server_url;
            this.prew_content.img_list = server_url + this.prew_content.url;
          } else {
            this.prew_content.img_list = this.g_url + this.prew_content.url;
          }

          this.$forceUpdate();
        }
        return;
      }
      let formdata = new FormData();
      formdata.append("url", this.prew_content.url);
      if (this.prew_cloud == "cloud") {
        formdata.append("from_cloud", 1);
      }
      let server_url = sessionStorage.server_url;
      let url =
        this.from_name == "videotapeCompetition"
          ? `${server_url}/school/upload/getResourceHtmlUrl`
          :( this.from_name == "research"?"/proxy2/cloud/upload/getResourceHtmlUrl":"/school/upload/getResourceHtmlUrl") ;
      this.axios
        .post(url, formdata)
        .then((res) => {
          if (res.data.code == 0) {
            this.show_alert("error", res.data.msg);
          }
          this.prew_content.img_list = res.data.data.data.img_list;
          this.$forceUpdate();

          //  console.log( this.prew_content.img_list)
        });
    }
  },
  methods: {
    //封装弹窗提示
    show_alert(type, data) {
      this.$message({
        type: type,
        message: data,
        duration: 1500,
        showClose: true,
      });
    },
    dowload() {
      let that = this
      console.log(this.prew_content)
      var xhr = new XMLHttpRequest();
      xhr.open(
        "GET",
        this.prew_content.url.indexOf("http") > -1
          ? this.prew_content.url
          : JSON.parse(sessionStorage.userInfo).school.server_url + this.prew_content.url,
        true
      );
      xhr.responseType = "blob";
      xhr.onload = function () {
        if (xhr.status === 200) {
          var link = document.createElement("a");
          var body = document.querySelector("body");
          link.href = window.URL.createObjectURL(xhr.response);
          link.download = that.prew_content.name;
          link.style.display = "none";
          // link.target = "_blank";
          body.appendChild(link);
          link.click();
          body.removeChild(link);
          window.URL.revokeObjectURL(link.href);
        }
      };
      xhr.send();
    },
  },
};
</script>
<style scoped>
.pre_wrapper {
  display: flex;
  flex-direction: column;
  height: calc(75vh - 80px);
}

.head {
  height: 1px;
}

.content {
  flex: 1;
  overflow: auto;
}

.foot {
  height: 60px;
}
</style>